import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_RENT, EMPTY_USER} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-widget-loyer-moyen',
    templateUrl: './loyer-moyen.component.html',
    styleUrls: ['./loyer-moyen.component.scss']
})
export class LoyerMoyenComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() extChange = new EventEmitter();

    echartsIntance = null;
    echartsIntanceNew = null;
    user: User = Object.assign({}, EMPTY_USER);

    furnish = 0;
    nb_lots = 1;
    advice_rent_choice = '';
    advice_rent = 0;
    advice_rent_L = 0;
    advice_rent_U = 0;
    advice_rent_cL = 0;

    /**
     * Chart Loyer
     */
    rentChoice = {};

    options = {
        label: {
            show: true,
            position: 'insideRight',
            color: 'white',
            fontSize: 12,
            formatter: d => {
                return d.data > 0 ? parseFloat(d.data).toLocaleString('fr-FR', {
                    style: 'currency',
                    currency: 'EUR'
                }) : '';
            }
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: params => {
                if (params[0].name.includes('Votre projet')) {
                    return params[1].name + ' : ' + parseFloat(params[1].data).toLocaleString('fr-FR', {
                        style: 'currency',
                        currency: 'EUR'
                    });
                }

                if (isNaN(parseFloat(params[0].data)) || parseFloat(params[0].data) === 0) {
                    return params[0].name + ' : - <br/>';
                }
                return params[0].name + ' : ' + parseFloat(params[0].data).toLocaleString('fr-FR', {
                    style: 'currency',
                    currency: 'EUR'
                });
            },
        },
        grid: {
            left: '1%',
            right: '3%',
            top: '0',
            bottom: '15',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            max: function(value) {
                return value.max;
            }
        },
        yAxis: {
            type: 'category',
            data: [],
            axisLabel: {},
        },

        color: ['#54b0ed', '#1277AA'],
        series: []
    };

    data = {
        series: [],
    };

    optionsNewrent = {
        title: {
            text: 'Répartition des loyers',
            subtext: 'Par surface et nombre de pièces'
        },
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data: []
        },
        toolbox: {
            show: true,
        },
        grid: {
            left: '1%',
            right: '3%',
            top: '50px',
            bottom: '15',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: []
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                formatter: '{value} €'
            }
        },
        series: []
    };

    dataNewrent = {
        series: [],
    };

    constructor(
        public cityService: CityService,
        public adService: AdService,
        public deviceService: DeviceDetectorService,
        public authenticationService: AuthenticationService) {
    }

    get displaySquare(): number {
        if (this.favorite.square > 0) {
            return this.favorite.square;
        }
        const p = this.cityService.getRentValue(this.favorite.ad_city, this.advice_rent_choice);
        return p ? p.s_moy : 0;
    }

    edit(event, fields = '') {
        if (fields === 'furnish') {
            this.setData(this.furnish);
            this.rentChoice = {};
            if (this.furnish == 4) {
                // Coloc
                this.advice_rent_choice = 'city.loyer_moyen_ville.C';
            } else {
                if (this.cityService.rentFields[this.advice_rent_choice] == undefined) {
                    this.advice_rent_choice = 'city.loyer_moyen_petite_ville';
                }
                this.rentChoice = this.cityService.getRentChoice(this.favorite.ad_city, this.furnish);
                this.advice_rent_choice = this.advice_rent_choice.replace('_non_meuble', '');
                this.advice_rent_choice = this.advice_rent_choice.replace('_meuble', '');
                if (this.furnish === 1) {
                    this.advice_rent_choice = this.advice_rent_choice.replace('_ville.A', '_ville_meuble.A');
                    this.advice_rent_choice = this.advice_rent_choice.replace('_ville.M', '_ville_meuble.M');
                    this.advice_rent_choice = this.advice_rent_choice.replace('_piece[', '_piece_meuble[');
                } else if (this.furnish === 2) {
                    this.advice_rent_choice = this.advice_rent_choice.replace('_ville.A', '_ville_non_meuble.A');
                    this.advice_rent_choice = this.advice_rent_choice.replace('_ville.M', '_ville_non_meuble.M');
                    this.advice_rent_choice = this.advice_rent_choice.replace('_piece[', '_piece_non_meuble[');
                }
            }
        }

        let p = this.cityService.getRentValue(this.favorite.ad_city, this.advice_rent_choice);
        if (p) {
            let square = this.favorite.square;
            if (square == 0) {
                square = p.s_moy;
            }
            if (this.furnish == 4) {
                this.advice_rent = p.x0 * (this.favorite.rooms >= 2 ? this.favorite.rooms - 1 : this.favorite.rooms) + p.x1 * square;
                this.advice_rent_L = p.x0_l * (this.favorite.rooms >= 2 ? this.favorite.rooms - 1 : this.favorite.rooms) + p.x1_l * square;
                this.advice_rent_U = p.x0_u * (this.favorite.rooms >= 2 ? this.favorite.rooms - 1 : this.favorite.rooms) + p.x1_u * square;
            } else {
                this.advice_rent = p.x0 + p.x1 * square;
                this.advice_rent_L = p.x0_l + p.x1_l * square;
                this.advice_rent_U = p.x0_u + p.x1_u * square;
            }
            this.advice_rent_cL = p.cL;
        }
    }

    ngOnInit() {
        this.furnish = this.favorite.furnish;
        if (this.furnish == 3) {
            this.furnish = 1;
        }
        this.favorite = this.adService.updateValues(this.favorite);
        this.advice_rent_choice = this.favorite.advice_rent_real;
        this.advice_rent = this.favorite.advice_rent;
        this.advice_rent_L = this.favorite.advice_rent_L;
        this.advice_rent_U = this.favorite.advice_rent_U;
        this.advice_rent_cL = this.favorite.advice_rent_cL;

        this.setData(this.furnish);
        this.extChange.subscribe(data => {
            this.edit(null, '');
            this.setData(this.furnish);
        });
        this.user = this.authenticationService.currentUser;
    }

    calcOls(loyer, square = null) {
        if (!loyer) {
            return 0;
        }
        if (square == null) {
            square = loyer.s_moy;
        }
        return Math.round(loyer.x0 + loyer.x1 * square);
    }

    /**
     * Loyers par nombre de pièces correspondant à l'exploitation choisie.
     * Pas de repli : si la ville n'a pas de données pour cette exploitation, on n'affiche rien.
     */
    rentByPiece(furnish) {
        if (furnish === 1 || furnish === 3 || furnish === 4) {
            return this.favorite.ad_city.loyer_moyen_ville_nb_piece_meuble;
        }
        if (furnish === 2) {
            return this.favorite.ad_city.loyer_moyen_ville_nb_piece_non_meuble;
        }
        return this.favorite.ad_city.loyer_moyen_ville_nb_piece;
    }

    /**
     * Loyers appartement / maison correspondant à l'exploitation choisie.
     * Pas de repli : si la ville n'a pas de données pour cette exploitation, on n'affiche rien.
     */
    villeRent(furnish) {
        let rent: any = this.favorite.ad_city.loyer_moyen_ville;
        if (furnish === 1 || furnish === 3 || furnish === 4) {
            rent = this.favorite.ad_city.loyer_moyen_ville_meuble;
        } else if (furnish === 2) {
            rent = this.favorite.ad_city.loyer_moyen_ville_non_meuble;
        }
        return rent ? rent : {A: EMPTY_RENT, M: EMPTY_RENT};
    }

    setData(furnish) {

        this.optionsNewrent.xAxis.data = [];
        this.dataNewrent = {
            series: [],
        };

        const rentByPiece = this.rentByPiece(furnish);

        let start = 20;
        let end = 100;

        for (let i = 1; i <= 5; i++) {
            if (rentByPiece && rentByPiece[i]) {
                const loyer = rentByPiece[i];
                if (loyer.s_min < start) {
                    start = loyer.s_min - 5;
                }
                if (loyer.s_max > end) {
                    end = loyer.s_max + 5;
                }
            }
        }

        for (let j = start; j <= end; j++) {
            this.optionsNewrent.xAxis.data.push(j);
        }
        for (let i = 1; i <= 5; i++) {
            if (rentByPiece && rentByPiece[i]) {
                const loyer = rentByPiece[i];
                const data = [];
                for (let j = start; j <= end; j++) {
                    if (loyer && j >= loyer.s_min && j <= loyer.s_max) {
                        data[j - start] = this.calcOls(loyer, j);
                    } else {
                        data[j - start] = null;
                    }
                }
                this.dataNewrent.series.push(
                    {
                        name: [(this.deviceService.isMobile() ? '1 pièce' : '1 pièce / Studio'), '2 pièces', '3 pièces', '4 pièces', '5 pièces', 'Appartement', 'Maison', (this.deviceService.isMobile() ? 'Parking' : 'Garage / Parking')][i - 1],
                        type: 'line',
                        data,
                    }
                );
            }
        }

        const villeRent = this.villeRent(furnish);

        this.options.yAxis.data = [
            'Loyer pour un 1 pièces / Studio '+(furnish == 0 ? '(nu et meublé)' : (furnish == 1 || furnish === 3 || furnish === 4 ? 'meublé' : (furnish == 2 ? 'nu' : '')))+' de ' + (rentByPiece && rentByPiece[1] ? rentByPiece[1].s_moy : '') + 'm²',
            'Loyer pour un 2 pièces '+(furnish == 0 ? '(nu et meublé)' : (furnish == 1 || furnish === 3 || furnish === 4 ? 'meublé' : (furnish == 2 ? 'nu' : '')))+' de ' + (rentByPiece && rentByPiece[2] ? rentByPiece[2].s_moy : '') + 'm²',
            'Loyer pour un 3 pièces '+(furnish == 0 ? '(nu et meublé)' : (furnish == 1 || furnish === 3 || furnish === 4 ? 'meublé' : (furnish == 2 ? 'nu' : '')))+' de ' + (rentByPiece && rentByPiece[3] ? rentByPiece[3].s_moy : '') + 'm²',
            'Loyer pour un 4 pièces '+(furnish == 0 ? '(nu et meublé)' : (furnish == 1 || furnish === 3 || furnish === 4 ? 'meublé' : (furnish == 2 ? 'nu' : '')))+' de ' + (rentByPiece && rentByPiece[4] ? rentByPiece[4].s_moy : '') + 'm²',
            'Loyer pour un 5 pièces '+(furnish == 0 ? '(nu et meublé)' : (furnish == 1 || furnish === 3 || furnish === 4 ? 'meublé' : (furnish == 2 ? 'nu' : '')))+' de ' + (rentByPiece && rentByPiece[5] ? rentByPiece[5].s_moy : '') + 'm²',
            'Loyer pour une colocation de ' + (this.favorite.rooms >= 2 ? this.favorite.rooms - 1 : this.favorite.rooms) + ' chambres',
            'Loyer pour un appartement '+(furnish == 0 ? '(nu et meublé)' : (furnish == 1 || furnish === 3 || furnish === 4 ? 'meublé' : (furnish == 2 ? 'nu' : '')))+' de ' + (villeRent.A ? villeRent.A.s_moy : '') + 'm²',
            'Loyer pour une maison '+(furnish == 0 ? '(nu et meublé)' : (furnish == 1 || furnish === 3 || furnish === 4 ? 'meublé' : (furnish == 2 ? 'nu' : '')))+' de ' + (villeRent.M ? villeRent.M.s_moy : '') + 'm²',
            'Loyer pour un garage / parking de ' + (this.favorite.ad_city.loyer_moyen_ville.P ? this.favorite.ad_city.loyer_moyen_ville.P.s_moy : '') + 'm²',
        ];

        const square = [];
        square['Loyer pour un 1 pièces / Studio '+(furnish == 0 ? '(nu et meublé)' : (furnish == 1 || furnish === 3 || furnish === 4 ? 'meublé' : (furnish == 2 ? 'nu' : '')))+' de ' + (rentByPiece && rentByPiece[1] ? rentByPiece[1].s_moy : '') + 'm²'] = (this.deviceService.isMobile() ? '1 pièce' : '1 pièce / Studio');
        square['Loyer pour un 2 pièces '+(furnish == 0 ? '(nu et meublé)' : (furnish == 1 || furnish === 3 || furnish === 4 ? 'meublé' : (furnish == 2 ? 'nu' : '')))+' de ' + (rentByPiece && rentByPiece[2] ? rentByPiece[2].s_moy : '') + 'm²'] = '2 pièces';
        square['Loyer pour un 3 pièces '+(furnish == 0 ? '(nu et meublé)' : (furnish == 1 || furnish === 3 || furnish === 4 ? 'meublé' : (furnish == 2 ? 'nu' : '')))+' de ' + (rentByPiece && rentByPiece[3] ? rentByPiece[3].s_moy : '') + 'm²'] = '3 pièces';
        square['Loyer pour un 4 pièces '+(furnish == 0 ? '(nu et meublé)' : (furnish == 1 || furnish === 3 || furnish === 4 ? 'meublé' : (furnish == 2 ? 'nu' : '')))+' de ' + (rentByPiece && rentByPiece[4] ? rentByPiece[4].s_moy : '') + 'm²'] = '4 pièces';
        square['Loyer pour un 5 pièces '+(furnish == 0 ? '(nu et meublé)' : (furnish == 1 || furnish === 3 || furnish === 4 ? 'meublé' : (furnish == 2 ? 'nu' : '')))+' de ' + (rentByPiece && rentByPiece[5] ? rentByPiece[5].s_moy : '') + 'm²'] = '5 pièces';
        square['Loyer pour une colocation de ' + (this.favorite.rooms >= 2 ? this.favorite.rooms - 1 : this.favorite.rooms) + ' chambres'] = 'Colocation';
        square['Loyer pour un appartement '+(furnish == 0 ? '(nu et meublé)' : (furnish == 1 || furnish === 3 || furnish === 4 ? 'meublé' : (furnish == 2 ? 'nu' : '')))+' de ' + (villeRent.A ? villeRent.A.s_moy : '') + 'm²'] = 'Appartement';
        square['Loyer pour une maison '+(furnish == 0 ? '(nu et meublé)' : (furnish == 1 || furnish === 3 || furnish === 4 ? 'meublé' : (furnish == 2 ? 'nu' : '')))+' de ' + (villeRent.M ? villeRent.M.s_moy : '') + 'm²'] = 'Maison';
        square['Loyer pour un garage / parking de ' + (this.favorite.ad_city.loyer_moyen_ville.P ? this.favorite.ad_city.loyer_moyen_ville.P.s_moy : '') + 'm²'] = (this.deviceService.isMobile() ? 'Parking' : 'Garage / Parking');

        this.options.yAxis.axisLabel = {
            formatter: function(value) {
                return square[value];
            },
        };

        this.data = {
            series: [
                {
                    name: this.favorite.ad_city.name,
                    type: 'bar',
                    stack: '1',
                    data: [
                        this.calcOls(rentByPiece && rentByPiece[1] ? rentByPiece[1] : EMPTY_RENT),
                        this.calcOls(rentByPiece && rentByPiece[2] ? rentByPiece[2] : EMPTY_RENT),
                        this.calcOls(rentByPiece && rentByPiece[3] ? rentByPiece[3] : EMPTY_RENT),
                        this.calcOls(rentByPiece && rentByPiece[4] ? rentByPiece[4] : EMPTY_RENT),
                        this.calcOls(rentByPiece && rentByPiece[5] ? rentByPiece[5] : EMPTY_RENT),
                        this.favorite.ad_city.loyer_moyen_ville_coloc.x0 * (this.favorite.rooms >= 2 ? this.favorite.rooms - 1 : this.favorite.rooms),
                        this.calcOls(villeRent.A),
                        this.calcOls(villeRent.M),
                        this.calcOls(this.favorite.ad_city.loyer_moyen_ville.P),
                        0,
                    ]
                },
            ]
        };

        if (this.favorite.id !== '') {
            this.options.yAxis.data.push('Votre projet : ' + this.favorite.square + 'm²');
            square['Votre projet : ' + this.favorite.square + 'm²'] = 'Votre projet';

            this.data.series.push(
                {
                    name: 'Votre projet',
                    type: 'bar',
                    stack: '1',
                    data: [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0, // One more for the city below
                        this.favorite.square > 0 ? (this.favorite.amount_rent / this.favorite.nb_lots).toPrecision(3) : 0,
                    ]
                });
        }

        if (this.favorite.ad_city.loyer_moyen_ville.A.lM > 0 || this.favorite.ad_city.loyer_moyen_ville.M.lM > 0) {
            this.options.yAxis.data = [this.favorite.ad_city.name + ' : ' + this.favorite.ad_city.loyer_moyen_petite_ville.s_moy + 'm²'].concat(this.options.yAxis.data);
            square[this.favorite.ad_city.name + ' : ' + this.favorite.ad_city.loyer_moyen_petite_ville.s_moy + 'm²'] = this.favorite.ad_city.name;
            this.data.series[0].data = [this.calcOls(this.favorite.ad_city.loyer_moyen_petite_ville)].concat(this.data.series[0].data);
        } else {
            this.options.yAxis.data = [this.favorite.ad_city.zip_code + ' : ' + this.favorite.ad_city.loyer_moyen_petite_ville_cp.s_moy + 'm²'].concat(this.options.yAxis.data);
            square[this.favorite.ad_city.zip_code + ' : ' + this.favorite.ad_city.loyer_moyen_petite_ville_cp.s_moy + 'm²'] = this.favorite.ad_city.zip_code;
            this.data.series[0].data = [this.calcOls(this.favorite.ad_city.loyer_moyen_petite_ville_cp)].concat(this.data.series[0].data);
        }

        this.rentChoice = this.cityService.getRentChoice(this.favorite.ad_city, this.furnish);

        if (this.echartsIntance) {
            this.echartsIntance.setOption(this.options);
        }
        if (this.echartsIntanceNew) {
            this.echartsIntanceNew.setOption(this.optionsNewrent);
        }
    }

    onChartInit(ec) {
        this.echartsIntance = ec;
    }

    onNewChartInit(ec) {
        this.echartsIntanceNew = ec;
    }
}
